import React, { useLayoutEffect, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useScrollRestoration } from "gatsby";
import { Tween, ScrollTrigger } from "react-gsap";
import { useCookies } from "react-cookie";

import Image from "../Global/Image";
import Link from "../Global/Link";

// ====

const Header = (props) => {
  const { settings, index } = props;

  const [cookies] = useCookies(["nf_lang"]);

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= 992 ? true : false
  );
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined" && window.innerWidth
  );
  const [screenHeight, setScreenHeight] = useState(
    typeof window !== "undefined" && window.innerHeight
  );
  const [videoWidth, setVideoWidth] = useState(
    typeof window !== "undefined" && window.innerWidth
  );
  const [videoHeight, setVideoHeight] = useState(
    typeof window !== "undefined" && (9 / 16) * window.innerWidth
  );
  const [logoPosition, setLogoPosition] = useState(
    typeof window !== "undefined" && ((9 / 16) * window.innerWidth) / 2
  );

  const [pageReady, setPageReady] = useState(false);
  const [logoAnimationReady, setLogoAnimationReady] = useState(false);

  const [logoAttach, setLogoAttach] = useState("nothing");

  const { detect } = require("detect-browser");

  const browser = detect();

  const detectMobile = () => {
    setIsMobile(window.innerWidth <= 992 ? true : false);

    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
    setVideoWidth(window.innerWidth);
    setVideoHeight((9 / 16) * window.innerWidth);
    setLogoPosition(((9 / 16) * window.innerWidth) / 2);

    setPageReady(true);

    if (index && typeof window !== "undefined" && window.scrollY === 0) {
      setLogoAnimationReady(true);
    }
  };

  const killAnimation = () => {
    if (screenWidth != window.innerWidth) {
      setPageReady(false);
      detectMobile();
    }

    //    alert("Browser resize: " + browser.os);
  };

  useEffect(() => {
    // Initial Mobile Check
    detectMobile();

    // Recheck if mobile on window resize
    if (typeof window !== "undefined") {
      window.addEventListener("resize", killAnimation);
    }

    return () => {
      // Remove event listener so we arent checking forever
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", killAnimation);
      }
    };
  }, []);

  const handleBurgerToggle = (toggleFlag) => {
    setMobileNavOpen((state) =>
      toggleFlag !== undefined ? toggleFlag : !state
    );
  };

  const handleScrollTrigger = (code) => {
    setLogoAttach(code);
  };

  const handleAllPositions = (what) => {
    const isBrowser = typeof window !== "undefined";

    if (!isBrowser) {
      return;
    }

    //    alert("Calc " + what);

    // const screenWidth = window.innerWidth;
    // const screenHeight = window.innerHeight;
    // let videoHeight = (9 / 16) * window.innerWidth; // Desktop
    let logoPercentFromTop = 40;
    let logoPositionInPixels = videoHeight / (100 / logoPercentFromTop); // Desktop
    let logoWidthStart = screenWidth / 2 + "px"; // Calc to get the width of the logo to start with
    let logoWidthEnd = 240 + "px"; // Set the end width

    if (screenWidth <= 992) {
      // Mobile
      // videoHeight = (16 / 9) * window.innerWidth; // Mobile
      logoPercentFromTop = 6;
      logoPositionInPixels = videoHeight / (100 / logoPercentFromTop); // Mobile
      logoWidthStart = (screenWidth / 3) * 2.5 + "px"; // Calc to get the width of the logo to start with
      logoWidthEnd = 200 + "px"; // Set the end width
    }
    const logoPosition = (logoPositionInPixels / screenHeight) * 100 + "%"; // This is a % of the screen

    if (what === "startPosition") {
      return "top " + videoHeight + "px";
    } else if (what === "endPosition") {
      return "top " + logoPosition;
    } else if (what === "logoPosition") {
      return logoPosition;
    } else if (what === "logoWidthStart") {
      return logoWidthStart;
    } else if (what === "logoWidthEnd") {
      return logoWidthEnd;
    }
  };

  return (
    <>
      <ScrollTrigger
        end={() => handleAllPositions("endPosition")}
        start={() => handleAllPositions("startPosition")}
        scrub
        trigger="#logo"
        toggleClass="brand-background-blue"
        onLeave={() => handleScrollTrigger("onLeave")}
        onEnterBack={() => handleScrollTrigger("onEnterBack")}
        //        markers
      >
        <header
          className={`brand-background-black sticky-top pt-3 pt-lg-4 ${
            logoAttach === "onLeave" || !index ? "brand-logo-connected" : ""
          }`}
        >
          <div
            className={`position-relative brand-logo-container ${
              pageReady ? "brand-logo-container-fade" : ""
            }`}
            id="logo"
          >
            <div
              className={`position-absolute top-0 brand-index-top brand-text-white brand-logo start-50 translate-middle-x`}
            >
              <Link to="/">
                <Image
                  src={settings?.logo?.filename}
                  alt={settings?.logo?.alt}
                  sm="200x0"
                  md="240x0"
                  lg="240x0"
                  className="w-100"
                />
              </Link>
            </div>
          </div>

          <nav className="w-100 px-3 px-lg-4 pb-2 pb-lg-4 d-flex flex-column flex-lg-row align-items-start justify-content-start">
            <span
              className="brand-menu-button-container brand-cursor"
              onClick={() => handleBurgerToggle()}
            >
              <span
                className={`brand-menu-button ${
                  mobileNavOpen ? "brand-menu-button-open" : ""
                }`}
              />
            </span>

            <div
              className={`${
                mobileNavOpen ? " brand-menu-open" : ""
              } d-flex flex-column d-lg-flex flex-lg-row justify-content-center justify-content-lg-between align-items-center p-0 w-100 brand-menu`}
            >
              <ul className="text-center list-unstyled m-0 d-flex flex-column my-5 my-lg-0 flex-lg-row">
                {settings?.header_navigation && (
                  <>
                    {settings?.header_navigation?.map((node, index) => {
                      return (
                        <li
                          className="my-3 me-0 my-lg-0 me-lg-3 brand-nav-item"
                          key={index}
                        >
                          <Link
                            to={node?.link}
                            target="_self"
                            partiallyActive={node.name === "" ? false : true}
                            key={node._uid}
                            className="small text-uppercase brand-nav-item-link"
                            onClick={() => handleBurgerToggle(false)}
                          >
                            {node.name}
                          </Link>
                        </li>
                      );
                    })}
                  </>
                )}
              </ul>
              <Link
                to={settings?.preorder_link}
                button="true"
                className="mb-4 mb-lg-0"
                onClick={() => handleBurgerToggle(false)}
              >
                {settings?.preorder_label}
              </Link>
            </div>
          </nav>
          <div className="d-flex flex-row justify-content-between brand-background-border brand-background-border-top position-absolute w-100">
            <img
              src="https://a.storyblok.com/f/156499/90x72/fbfe9592e6/border-top-left.png"
              alt=""
            />
            <img
              src="https://a.storyblok.com/f/156499/90x72/41fffb8198/border-top-right.png"
              alt=""
            />
          </div>
        </header>
      </ScrollTrigger>
    </>
  );
};

export default Header;

Header.propTypes = {
  settings: PropTypes.object,
};

Header.defaultProps = {
  settings: null,
};
